export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14138.06ff9a08.jpg";